"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

var _getEnvironment = require("./getEnvironment");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Driver = void 0;

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var Driver = /*#__PURE__*/function () {
  function Driver() {
    _classCallCheck(this, Driver);

    _defineProperty(this, "_listeners", []);
  }

  _createClass(Driver, [{
    key: "install",
    value: function install() {
      return window.native && console.warn("Warn 29631: Bridge Modern\uC758 \uD1B5\uC2E0 \uB4DC\uB77C\uC774\uBC84\uAC00 \uC774\uBBF8 \uC124\uCE58\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4. \uAE30\uC874\uC758 Bridge\uB97C \uB36E\uC5B4\uC4F0\uBBC0\uB85C \uBE44\uC815\uC0C1\uC801\uC778 \uC791\uB3D9\uC774 \uC788\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uD639\uC2DC Bridge \uAC1D\uCCB4\uAC00 \uC5EC\uB7EC\uBC88 \uC0DD\uC131\uB418\uACE0 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694."), window.native = this, this;
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      delete window.native;
    }
  }, {
    key: "postMessage",
    value: function postMessage(a) {
      var b, c;

      switch ((0, _getEnvironment.getEnvironment)()) {
        case "Android":
          null === (b = window.AndroidFunction) || void 0 === b ? void 0 : b.messageHandler(JSON.stringify(a));
          break;

        case "Cupertino":
          null === (c = window.webkit) || void 0 === c ? void 0 : c.messageHandlers.messageHandler.postMessage(JSON.stringify(a));
          break;

        case "Web":
          console.warn("Warn 31993: Bridge Modern\uC758 \uD1B5\uC2E0 \uB4DC\uB77C\uC774\uBC84\uB294 \uBE0C\uB77C\uC6B0\uC800 \uD658\uACBD\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uD604\uC7AC Bridge\uAC00 \uC0DD\uC131\uB41C \uD658\uACBD\uC774 WebView \uD658\uACBD\uC778\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.");
      }
    }
  }, {
    key: "addMessageListener",
    value: function addMessageListener(a) {
      this._listeners.push(a);

      var b = this;
      return function () {
        var c = b._listeners.findIndex(function (b) {
          return b === a;
        });

        b._listeners.splice(c, 1);
      };
    }
  }, {
    key: "onMessage",
    value: function onMessage(a) {
      return a ? void this._listeners.map(function (b) {
        return b(a);
      }) : console.warn("Warn 35010: \uBA54\uC2DC\uC9C0\uAC00 \uB3C4\uCC29\uD558\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4");
    }
  }]);

  return Driver;
}();

exports.Driver = Driver;